import {
  HalfYearExtensionReason,
  YesOrNoFlug,
} from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";
import { monthMapping } from "../parts";
/**
 * 育休テーブルを作成する
 * @param res
 * @returns infoBodyList
 */
function funInfoBodyList(res: any) {
  const infoBodyList = res?.map((item: any) => [
    {
      children: item.birthday, //出産日
      align: "center",
    },
    {
      children: item.startDate, //育児休業開始日
      align: "center",
    },
    {
      children: item.endDate, //育児休業終了日
      align: "center",
    },
    {
      children: TkGetCode(YesOrNoFlug, item.papaMamaFlg), //パパママ育休プラス
      align: "center",
    },
    {
      children: TkGetCode(YesOrNoFlug, item.papaChildcareLeaveFlg), //産後パパ育休
      align: "center",
    },
    {
      children: TkGetCode(HalfYearExtensionReason, item.halfyearExtendReason), //半年延長の理由
    },
  ]);

  return infoBodyList ?? [];
}

/**
 * 処理履歴を作成する
 * @param res
 * @returns statusBodyList
 */
function funStatusBodyList(res: any) {
  const statusBodyList: any[] = [];
  for (let i in res) {
    let createDate = new Date(res[i].createDate);
    const data = [
      {
        children: res[i].managerName,
      },
      {
        children: res[i].process,
      },
      {
        children:
          createDate.getFullYear() +
          "/" +
          (createDate.getMonth() + 1) +
          "/" +
          createDate.getDate(),
        align: "center",
      },
      {
        children: res[i].processComment,
      },
    ];
    statusBodyList.push(data);
  }

  return statusBodyList;
}

function convertMonths(monthList: any) {
  let selectedMonths = [];
  let newMonthList: any[] = [];
  if (Array.isArray(monthList)) {
    newMonthList = monthList[0];
  } else {
    newMonthList = monthList;
  }
  for (let month in newMonthList) {
    if (month === "year") continue;

    if (newMonthList[month] === "1") {
      selectedMonths.push(monthMapping[month]);
    }
  }
  return selectedMonths;
}

export { funInfoBodyList, funStatusBodyList, convertMonths };
